DJ.addBehavior('js-thematic-lists', '.js-thematic-lists', {
  attach: function(context, settings, behavior) {
    const $this = jQuery(this),
          $thisChild = $this.find('.mag-thematic--list'),
          $thisBtn = jQuery('.mag-thematic--btn'),
          $active = 'active';

    if ($thisChild.length > 1) $this.addClass('has-more-childs');

    $thisChild.eq(0).addClass($active);

    $thisFirstActive = $this.find('.mag-thematic--list:not(:first)');

    $thisBtn.on('click touchstart', function () {
      $thisBtnClk = jQuery(this);
      let $activeNext =  $this.find('.active').next('.mag-thematic--list');
      let $activeItem =  $this.find('.active');
      if($activeNext.length > 0 ){
        $activeNext.addClass($active);
      }

      if($activeNext.length + 1 === $thisChild.length){
        $thisBtn.addClass('hidden')
        $thisBtnClk.addClass('less');
        $thisBtn.find('span:first-child').text(Drupal.t('show less'));
      }

      if($activeItem.length === $thisChild.length ){
        jQuery(this).removeClass('less');
        $thisBtn.find('span:first-child').text(Drupal.t('show more'));
        $thisFirstActive.removeClass($active);

        jQuery('html, body').animate({
          scrollTop: $this.offset().top - 100
        }, 500);
      }
      return false;
    });


  },

  detach: function(context, settings) {}
});
